import React from "react";
import { animated, useSpring } from "react-spring";

interface Props {
    children: any;
    expanded: boolean;
}

export function Collapsible(props: Props) {
    const { expanded, children } = props;
    const contentRef = React.useRef(null);

    const springProps = useSpring({
        to: expanded
            ? async (next) => {
                  await next({ display: "block" });
                  await next({
                      opacity: 1,
                      height: contentRef.current ? contentRef.current.clientHeight : 0,
                  });
                  await next({ height: "" });
              }
            : async (next) => {
                  await next({ height: contentRef.current ? contentRef.current.clientHeight : 0 });
                  await next({ opacity: 0, height: 0 });
                  await next({ display: "none" });
              },
        from: expanded
            ? { opacity: 1, display: "block", overflow: "hidden" }
            : { opacity: 0, display: "none", overflow: "hidden", height: 0 },
        config: { duration: 200 },
        delay: 200,
    });

    return (
        <animated.div style={springProps}>
            <div ref={contentRef} style={{ display: "inline-block", width: "100%" }}>
                {children}
            </div>
        </animated.div>
    );
}
